// Prestige Shop — minimal theme JS
(function () {
  // Cmd-K focuses search
  document.addEventListener('keydown', function (e) {
    var isCmdK = (e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === 'k';
    if (isCmdK) {
      var input = document.querySelector('.hdr-search input[name="q"]');
      if (input) { e.preventDefault(); input.focus(); }
    }
  });

  // Tabs (product page)
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var btns = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-tab-btn');
        btns.forEach(function (b) { b.setAttribute('data-active', b === btn ? 'true' : 'false'); });
        panels.forEach(function (p) {
          p.style.display = (p.getAttribute('data-tab-panel') === key) ? '' : 'none';
        });
      });
    });
  });

  // Collection view toggle (grid/list)
  document.querySelectorAll('[data-view-toggle]').forEach(function (root) {
    var grid = root.querySelector('[data-view="grid-btn"]');
    var list = root.querySelector('[data-view="list-btn"]');
    var target = document.querySelector('[data-view-target]');
    if (!target) return;
    function set(mode) {
      target.setAttribute('data-view-mode', mode);
      if (grid) grid.setAttribute('data-active', mode === 'grid' ? 'true' : 'false');
      if (list) list.setAttribute('data-active', mode === 'list' ? 'true' : 'false');
      try { localStorage.setItem('ps_view', mode); } catch (e) {}
    }
    if (grid) grid.addEventListener('click', function () { set('grid'); });
    if (list) list.addEventListener('click', function () { set('list'); });
    var saved = null;
    try { saved = localStorage.getItem('ps_view'); } catch (e) {}
    if (saved === 'list' || saved === 'grid') set(saved);
  });

  // Filter accordion (collection sidebar)
  document.querySelectorAll('[data-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var key = head.getAttribute('data-acc-head');
      var body = document.querySelector('[data-acc-body="' + key + '"]');
      if (!body) return;
      var open = body.style.display !== 'none';
      body.style.display = open ? 'none' : '';
      head.setAttribute('data-open', open ? 'false' : 'true');
    });
  });
})();
